import { render, staticRenderFns } from "./IntranetRemoval.vue?vue&type=template&id=5a611b34&scoped=true&"
import script from "./IntranetRemoval.vue?vue&type=script&lang=ts&"
export * from "./IntranetRemoval.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a611b34",
  null
  
)

export default component.exports